import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getSPI from './SPI';
const demandServicePath = (productName, clouldId) => "/internal/demand/app-requests/product-name/".concat(productName, "/cloud-id/").concat(clouldId);

// Request for an app
const requestAppUrl = (productName, cloudId, appKey) => "".concat(demandServicePath(productName, cloudId), "/app-key/").concat(appKey);

// Get a status of the app request for an app key
const getAppRequestedStatusUrl = params => "".concat(demandServicePath(params.productName, params.cloudId), "/app-key/").concat(params.appKey, "/status?userId=").concat(params.userId);

// Get all the app requests to render Manage App requests dashboard
const getAppRequestsUrl = (productName, cloudId) => "".concat(demandServicePath(productName, cloudId));

// Update the status of an app (for ex: Installed | Rejected)
const updateAllAppRequestStatusUrl = (productName, cloudId, appKey) => "".concat(demandServicePath(productName, cloudId), "/app-key/").concat(appKey, "/status");

// Get all the user comments for an app
const getAppRequestCommentsUrl = _ref => {
  let {
    productName,
    cloudId,
    appKey
  } = _ref;
  return "".concat(demandServicePath(productName, cloudId), "/app-key/").concat(appKey);
};
const defaultDemandApiConfig = {
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json'
  }
};
export const getAppRequests = (productName, cloudId) => getSPI().fetchOk(getAppRequestsUrl(productName, cloudId), defaultDemandApiConfig).catch(error => {
  if (error.status === 404) {
    return {
      allAppRequestDetails: []
    };
  }
  throw error;
});
export const getAppRequestComments = requestParams => getSPI().fetchOk(getAppRequestCommentsUrl(requestParams), defaultDemandApiConfig);
export const requestApp = appRequestDetails => getSPI().fetchOk(requestAppUrl(appRequestDetails.productName, appRequestDetails.cloudId, appRequestDetails.appKey), _objectSpread({
  method: 'post',
  body: JSON.stringify(appRequestDetails)
}, defaultDemandApiConfig));
export const getAppRequestedStatus = appRequestStatusParams => getSPI().fetchOk(getAppRequestedStatusUrl(appRequestStatusParams), defaultDemandApiConfig);
export const changeAppRequestStatus = requestParams => getSPI().fetchOk(updateAllAppRequestStatusUrl(requestParams.productName, requestParams.cloudId, requestParams.appKey), _objectSpread({
  method: 'PATCH',
  body: JSON.stringify(requestParams)
}, defaultDemandApiConfig));